import { toast } from "react-toastify";
import ImageIcon from "@mui/icons-material/Image";
import { MintUploadArtWorkProps } from "./types";
import { mintUploadArtWorkStyles } from "./styles";
import { TEXT_COLOR } from "../../theme";

export const MintUploadArtWork: React.FC<MintUploadArtWorkProps> = ({
  errors,
  touched,
  previewUrl,
  handleBlur,
  handleDragOver,
  setFieldValue,
  handleFile,
  setImageChanged,
  isSubmitting,
}) => {
  return (
    <>
      <label
        style={{
          color:
            errors.coverArtUpload && touched.coverArtUpload
              ? "red"
              : TEXT_COLOR,
        }}
        htmlFor="artwork"
        className="uploadLabel"
      >
        Upload Artwork
        <span className="asterisk">*</span>
      </label>
      <label
        htmlFor="cover-art-upload"
        className="image-upload cover-upload"
        style={{
          borderStyle: previewUrl ? "none" : "dashed",
          borderWidth: "2px",
          borderColor:
            errors.coverArtUpload && touched.coverArtUpload
              ? "red"
              : TEXT_COLOR,
        }}
        onBlur={handleBlur}
        onDragOver={handleDragOver}
        onDrop={(event: any) => {
          //prevent the browser from opening the image
          event.preventDefault();
          event.stopPropagation();
          if (
            event.dataTransfer.files[0] &&
            event.dataTransfer.files[0]?.type?.split("/")[0] !== "image"
          ) {
            toast.info("Upload an image file");
          } else {
            setFieldValue("coverArtUpload", event.dataTransfer.files[0]);
            const imageFile = event.dataTransfer.files[0];
            handleFile(imageFile);
            setImageChanged(true);
          }
        }}
        onClick={handleBlur}
      >
        <input
          style={{ color: "white", backgroundColor: TEXT_COLOR }}
          type="file"
          name="coverArtUpload"
          id="cover-art-upload"
          onChange={(event: any) => {
            handleFile(event.target.files[0]);
            setFieldValue("coverArtUpload", event.currentTarget.files?.[0]);
            setImageChanged(true);
            event.currentTarget.value = "";
          }}
          accept="image/*"
          onBlur={handleBlur}
          disabled={isSubmitting}
        />
        {!previewUrl && (
          <>
            <ImageIcon sx={mintUploadArtWorkStyles.imageIcon} />
            <img style={{ color: TEXT_COLOR }} alt="" className="edit" />
          </>
        )}

        {previewUrl && (
          <img
            src={previewUrl}
            alt="cover"
            height={"100%"}
            width={"100%"}
            color={TEXT_COLOR}
          />
        )}
      </label>
      <p style={{ color: TEXT_COLOR }} className="input-description">
        Image type supported: JPG or JPEG. Max size 10 MB
      </p>
      <p
        className="input-description"
        style={{ marginTop: -25, color: TEXT_COLOR }}
      >
        Square at least 3000x3000 pixels, not blurry or pixelated.
      </p>
    </>
  );
};
